import { getNonHomeownerUserById } from "@/features/volunteers/api/volunteers.api"
import type { Volunteer } from "../types/volunteers.type"

/** Refetch user by id and merge fresh `volunteer.serveDates` for Update Volunteer (stale props often omit them). */
export async function hydrateVolunteerServeDates(volunteer: Volunteer): Promise<Volunteer> {
    const userId = volunteer.user?.id
    if (userId == null) return volunteer
    const res = await getNonHomeownerUserById(userId)
    if (!res.success || !res.data?.volunteer) return volunteer
    const fresh = res.data.volunteer.serveDates
    return {
        ...volunteer,
        serveDates: fresh !== undefined && fresh !== null ? fresh : volunteer.serveDates ?? null,
    }
}
